import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { Button } from './ui/Button';
export function FinalCTA() {
  return <section className="py-20 bg-white border-t border-gray-100" data-id="element-101">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-102">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto" data-id="element-103">
          <h2 className="text-4xl lg:text-5xl font-black text-gray-900 mb-6" data-id="element-104">
            Klaar om te beginnen?
          </h2>
          <p className="text-xl text-gray-600 mb-8" data-id="element-105">
            Je kent Anifit. Je weet wat het kan doen voor je hond.
            <br data-id="element-106" />
            Nu is het tijd om de stap te zetten.
          </p>

          <div className="flex flex-col md:flex-row justify-center gap-4 md:gap-8 mb-10" data-id="element-107">
            <div className="flex items-center justify-center gap-2" data-id="element-108">
              <div className="w-5 h-5 rounded-full bg-[#4DBFB8]/20 flex items-center justify-center" data-id="element-109">
                <Check className="w-3 h-3 text-[#4DBFB8]" data-id="element-110" />
              </div>
              <span className="font-medium text-gray-800" data-id="element-111">
                10% korting met code: stressless
              </span>
            </div>
            <div className="flex items-center justify-center gap-2" data-id="element-112">
              <div className="w-5 h-5 rounded-full bg-[#4DBFB8]/20 flex items-center justify-center" data-id="element-113">
                <Check className="w-3 h-3 text-[#4DBFB8]" data-id="element-114" />
              </div>
              <span className="font-medium text-gray-800" data-id="element-115">
                Gratis persoonlijk voedingsadvies
              </span>
            </div>
            <div className="flex items-center justify-center gap-2" data-id="element-116">
              <div className="w-5 h-5 rounded-full bg-[#4DBFB8]/20 flex items-center justify-center" data-id="element-117">
                <Check className="w-3 h-3 text-[#4DBFB8]" data-id="element-118" />
              </div>
              <span className="font-medium text-gray-800" data-id="element-119">
                Begeleiding tijdens de overstap
              </span>
            </div>
          </div>

          <a href="https://www.anifit.com/content/dierenvoeding/shop/shop/article/284458/proefpakket_hond_400g_1_set_met_verschillende_soorten_natvoer_vlokken_en_testpakketten_?new_client_country=NL&category=62183&refconsultant=487050" target="_blank" rel="noopener noreferrer" data-id="element-120">
            <Button className="w-full sm:w-auto text-xl px-10 py-5 shadow-2xl shadow-[#E85D5D]/30 mb-8" data-id="element-121">
              👉 BESTEL NU JE ANIFIT PROEFPAKKET 👈
            </Button>
          </a>

          <p className="text-gray-500" data-id="element-122">
            Vragen? We helpen je graag:{' '}
            <a href="mailto:amee@stresslessdogs.nl" className="text-[#4DBFB8] font-bold hover:underline" data-id="element-123">
              amee@stresslessdogs.nl
            </a>
          </p>
        </motion.div>
      </div>
    </section>;
}